import React from "react";
import { Fade } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

export default function ModernUnauthorized() {
  return (
    <Fade in={true} timeout={1000}>
      <SuiBox display="flex" justifyContent="center" alignItems="center" minHeight="100vh" px={2}>
        <SuiBox
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          position="relative"
          width={{ xs: "80vw", sm: "50vw", md: "35vw" }}
          height={{ xs: "40vh", sm: "40vh", md: "40vh" }}
          backgroundColor="info"
          backgroundGradient
          borderRadius="lg"
          p={4}
          textAlign="center"
          boxShadow="lg"
        >
          {/* LockIcon ajustado */}
          <LockIcon
            sx={{
              position: "absolute",
              top: "-30px",
              left: "-30px",
              fontSize: "120px !important", // Tamaño ajustado sin usar !important
              color: "#FFFFFF",
              filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
              zIndex: 1,
            }}
          />

          {/* Efecto de desvanecimiento para "OOPS!" */}
          <SuiTypography
            variant="h1"
            fontSize="120px" // Se mantiene el tamaño grande solo para OOPS!
            fontWeight="bold"
            gutterBottom
            align="center"
            sx={{
              background: "-webkit-linear-gradient(#ffffff 0%, transparent 70%)", // Gradiente para desvanecer hacia abajo
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              lineHeight: 1,
              position: "absolute",
              top: "15%",
              zIndex: 0, // Se coloca detrás del texto principal
              width: "100%",
              opacity: 0.1, // Reduce la opacidad para el efecto de fondo
            }}
          >
            OOPS!
          </SuiTypography>

          {/* Texto principal superpuesto */}
          <SuiBox position="relative" zIndex={2} mt={2}>
            <SuiTypography
              variant="h1"
              component="h1"
              gutterBottom
              align="center"
              textColor="white"
            >
              Sin autorización
            </SuiTypography>
            <SuiTypography variant="h6" align="center" textColor="white" paragraph>
              Lo sentimos, no tienes permiso para acceder a esta página. Si crees que esto es un
              error, por favor contacta al administrador del sistema.
            </SuiTypography>
          </SuiBox>
        </SuiBox>
      </SuiBox>
    </Fade>
  );
}
